module.exports = __webpack_public_path__ + "static/media/wallet.c92f641b.svg";